import type { ProgressCategory } from "./progress-category";
import { ProgressItemStatus } from "./progress-item-status";

export class ProgressCategoryExtensions {
    public constructor(private category: ProgressCategory) { }

    public get isComplete() {
        const items = (this.category.progressItems ?? [])
            .filter((item) => item && !item.entityAspect.entityState.isDetached());
        return items.length > 0 && items.every((item) => item.status === ProgressItemStatus.Done);
    }
}
